const MONTH_NAMES = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

export function weekLabel(week: string): string {
  const [year, month, day] = week.split('-')
  const name = MONTH_NAMES[Number(month) - 1]
  if (name === undefined || year === undefined || day === undefined) return week
  return `${name} ${Number(day).toString()}, ${year}`
}

export function weekShort(week: string): string {
  const [, month, day] = week.split('-')
  const name = MONTH_NAMES[Number(month) - 1]
  if (name === undefined || day === undefined) return week
  return `${name} ${Number(day).toString()}`
}

export function formatDateTime(value: string | null): string {
  if (value === null) return ''
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}
